import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const Homepage = () => {
  const sections = [
    {
      title: 'Profile Management - Customers',
      path: '/profile/profile-management/customers'
    },
    {
      title: 'Profile Management - Stores',
      path: '/profile/profile-management/stores'
    },
    {
      title: "Customer's Okta Status",
      path: '/profile/onboarding-status/okta-status/active'
    },
    {
      title: 'Stores Missing Product List',
      path: '/profile/onboarding-status/missing-product-list'
    },
    {
      title: 'Stores Missing Visit List',
      path: '/profile/onboarding-status/missing-visit-list'
    },
    {
      title: 'Stores Missing MOA',
      path: '/profile/onboarding-status/missing-moa'
    },
    {
      title: 'Stores Missing Cut Off Time',
      path: '/profile/onboarding-status/missing-cut-off-time'
    },
    {
      title: 'Stores Missing Delivery Service',
      path: '/profile/onboarding-status/missing-delivery-service'
    },
    {
      title: 'Stores Missing Delivery Days',
      path: '/profile/onboarding-status/missing-delivery-days'
    },
    // {
    //   title: 'Missing Promo Data',
    //   path: '/profile/onboarding-status/missing-promo-data'
    // },
    {
      title: 'Missing Activity Data',
      path: '/profile/onboarding-status/missing-activity-data'
    },
    {
      title: 'Missing Segments Data',
      path: '/profile/onboarding-status/missing-segments-data'
    },
    // {
    //   title: 'Missing Targets Data',
    //   path: '/profile/onboarding-status/missing-targets-data'
    // }
    
  ];

  return (
    <Container maxWidth='lg' sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant='h3' component='h1' gutterBottom>
          B2B Profile Admin Dashboard
        </Typography>
        <Typography variant='subtitle1' color='text.secondary'>
          Select a section to manage different aspects of the B2B platform
        </Typography>
      </Box>

      <List>
        {sections.map(section => (
          <ListItem
            key={section.path}
            component={Link}
            to={section.path}
            sx={{
              textDecoration: 'none',
              color: 'inherit',
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}>
            <ListItemText
              primary={section.title}
              secondary={section.description}
            />
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default Homepage;
